export const COMPONENT_NAME = 'SocialShare';
